import { downloadFile } from './downloadFile';

/* istanbul ignore next */
export function exportTableToCsv(data: string[][], filename: string) {
  const csvContent = data
    .map((row) => row.map((item) => item.replaceAll('"', '""')))
    .map((row) => row.map((item) => `"${item}"`))
    .map((row) => row.join(','))
    .join('\n');
  const csvFile = new Blob([csvContent], { type: 'text/csv' });

  downloadFile(csvFile, filename);
}
